import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_FAVORITED_PRODUCT_IDS } from 'mocks/queries';

const useFavoriteCount = () => {
  const { data } = useSuspenseQuery(GET_FAVORITED_PRODUCT_IDS);
  return data?.productIds.length ?? 0;
};

export default useFavoriteCount;
